import { ExpandableItemsListDrawer } from '../../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { useAutoExpandFlow, type FlowProps } from '../../../hooks'
import { useStore } from '../../../store'
import type AppStore from '../../../store/AppStore'

export function usePerishableProductFlow(store: AppStore): FlowProps {
  return useAutoExpandFlow(store)
}

export default function PerishableProductExpandableList() {
  const store = useStore()
  const flow = usePerishableProductFlow(store)
  return <ExpandableItemsListDrawer {...flow} />
}
